import { toast, Slide } from "react-toastify";

class ToastUtils {
  serverError() {
    toast.error("Πρόβλημα επικοινωνίας με το Server!", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      theme: "colored",
    });
  }

  success(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      theme: "colored",
    });
  }

  error(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      theme: "colored",
    });
  }
}

export default new ToastUtils();
